import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'

import * as Sentry from '@sentry/vue'

import App from './App.vue'
import store from './store/'
import router from './router'

import locales from './locales'

import vPage from './components/page/index.vue'
import vInput from './components/input.vue'
import vButton from './components/button.vue'
import vSwitch from './components/switch'

import '@/assets/fa.5.15.min.css'
import '@/assets/mapbox.css'
import 'virtual:windi.css' // eslint-disable-line import/no-unresolved
import '@/assets/styles.css'

const app = createApp(App)

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://4159fccdbb4f4bfa8e85db0fc8d3544f@sentry.krknet.de/45',
    release: process.env.VUE_APP_RELEASE,
    attachProps: true,
    attachStacktrace: true
  })
}

const i18n = createI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages: locales
})

app
  .use(router)
  .use(store)
  .use(i18n)
  .component('v-input', vInput)
  .component('v-button', vButton)
  .component('v-switch', vSwitch)
  .component('v-page', vPage)
  .mount('#app')
